import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import { FirstAndThirdPartyDashboardCardDataTitles } from '~/src/dash/views/measurement-home-view';

// ---------------------- First And Third Party dashboard -----------------------------
export const dashboardTitleTrackedAds = 'Tracked Ads' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleImpressionsRendered =
  'Impressions Rendered' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleRenderRate = 'Render Rate' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleInvalidTrafficAds =
  'Invalid Traffic Ads' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleInvalidTrafficRate =
  'Invalid Traffic Rate' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleEligibleAds =
  'Eligible Ads' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleMeasuredAds =
  'Measured Ads' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleMeasuredRate =
  'Measured Rate' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleViewableImpressions =
  'Viewable Impressions' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleViewableRate =
  'Viewable Rate' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleBlockedAds = 'Blocked Ads' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleBlockedRate =
  'Blocked Rate' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleSuspiciousImps =
  'Invalid Traffic Ads' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleUnsuspiciousImps =
  'Valid Traffic' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleUnviewableImps =
  'Non-Viewable Ads' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleBlockedImps = 'Blocked Ads' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitlePassedAds = 'Passed Ads' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleAudibleViewableCustomQ2 =
  'AVOC GroupM Count' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleAudibleViewableIndStdQ4 =
  'AVOC Count' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleAVOCGroupMRate =
  'AVOC GroupM Rate' as FirstAndThirdPartyDashboardCardDataTitles;
export const dashboardTitleAVOCRate = 'AVOC Rate' as FirstAndThirdPartyDashboardCardDataTitles;

export const dashboardKeyTrackedAds = 'TrackedAds';
export const dashboardKeyImpressionsRendered = 'RenderedImpressions';
export const dashboardKeyRenderRate = 'RenderRate';
export const dashboardKeyInvalidTrafficAds = 'IVTAds';
export const dashboardKeyInvalidTrafficRate = 'IVTRate';
export const dashboardKeyEligibleAds = 'EligibleAds';
export const dashboardKeyMeasuredAds = 'MeasuredAds';
export const dashboardKeyMeasuredRate = 'MeasuredRate';
export const dashboardKeyViewableImpressions = 'ViewableImpressions';
export const dashboardKeyViewableRate = 'ViewabilityRate';
export const dashboardKeyBlockedAds = 'AdBlockCount';
export const dashboardKeyBlockedRate = 'AdBlockRate';
export const dashboardKeySuspiciousImps = 'SuspiciousImps';
export const dashboardKeyUnsuspiciousImps = 'UnsuspiciousImps';
export const dashboardKeyUnviewableImps = 'UnviewableImps';
export const dashboardKeyBlockedImps = 'BlockedImps';
export const dashboardKeyPassedAds = 'PassedAds';
export const dashboardKeyAudibleViewableCustomQ2 = 'AudibleViewableCustomQ2';
export const dashboardKeyAudibleViewableIndStdQ4 = 'AudibleViewableIndStdQ4';
export const dashboardKeyAVOCGroupMRate = 'AVOCGroupMRate';
export const dashboardKeyAVOCRate = 'AVOCRate';

export const dashboardCompareKeyTrackedAds = 'CompareTrackedAds';
export const dashboardCompareKeyImpressionsRendered = 'CompareRenderedImpressions';
export const dashboardCompareKeyRenderRate = 'CompareRenderRate';
export const dashboardCompareKeyInvalidTrafficAds = 'CompareIVTAds';
export const dashboardCompareKeyInvalidTrafficRate = 'CompareIVTRate';
export const dashboardCompareKeyEligibleAds = 'CompareEligibleAds';
export const dashboardCompareKeyMeasuredAds = 'CompareMeasuredAds';
export const dashboardCompareKeyMeasuredRate = 'CompareMeasuredRate';
export const dashboardCompareKeyViewableImpressions = 'CompareViewableImpressions';
export const dashboardCompareKeyViewableRate = 'CompareViewabilityRate';
export const dashboardCompareKeyBlockedAds = 'CompareAdBlockCount';
export const dashboardCompareKeyBlockedRate = 'CompareAdBlockRate';
export const dashboardCompareKeySuspiciousImps = 'CompareSuspiciousImps';
export const dashboardCompareKeyUnsuspiciousImps = 'CompareUnsuspiciousImps';
export const dashboardCompareKeyUnviewableImps = 'CompareUnviewableImps';
export const dashboardCompareKeyBlockedImps = 'CompareBlockedImps';
export const dashboardCompareKeyPassedAds = 'ComparePassedAds';
export const dashboardCompareKeyAudibleViewableCustomQ2 = 'CompareAudibleViewableCustomQ2';
export const dashboardCompareKeyAudibleViewableIndStdQ4 = 'CompareAudibleViewableIndStdQ4';
export const dashboardCompareKeyAVOCGroupMRate = 'CompareAVOCGroupMRate';
export const dashboardCompareKeyAVOCRate = 'CompareAVOCRate';

export const dashboardKeysToTitlesMapping = {
  [dashboardKeyTrackedAds]: dashboardTitleTrackedAds,
  [dashboardKeyImpressionsRendered]: dashboardTitleImpressionsRendered,
  [dashboardKeyRenderRate]: dashboardTitleRenderRate,
  [dashboardKeyInvalidTrafficAds]: dashboardTitleInvalidTrafficAds,
  [dashboardKeyInvalidTrafficRate]: dashboardTitleInvalidTrafficRate,
  [dashboardKeyEligibleAds]: dashboardTitleEligibleAds,
  [dashboardKeyMeasuredAds]: dashboardTitleMeasuredAds,
  [dashboardKeyMeasuredRate]: dashboardTitleMeasuredRate,
  [dashboardKeyViewableImpressions]: dashboardTitleViewableImpressions,
  [dashboardKeyViewableRate]: dashboardTitleViewableRate,
  [dashboardKeyBlockedAds]: dashboardTitleBlockedAds,
  [dashboardKeyBlockedRate]: dashboardTitleBlockedRate,
  [dashboardKeySuspiciousImps]: dashboardTitleSuspiciousImps,
  [dashboardKeyUnsuspiciousImps]: dashboardTitleUnsuspiciousImps,
  [dashboardKeyUnviewableImps]: dashboardTitleUnviewableImps,
  [dashboardKeyBlockedImps]: dashboardTitleBlockedImps,
  [dashboardKeyPassedAds]: dashboardTitlePassedAds,
  [dashboardKeyAudibleViewableCustomQ2]: dashboardTitleAudibleViewableCustomQ2,
  [dashboardKeyAudibleViewableIndStdQ4]: dashboardTitleAudibleViewableIndStdQ4,
  [dashboardKeyAVOCGroupMRate]: dashboardTitleAVOCGroupMRate,
  [dashboardKeyAVOCRate]: dashboardTitleAVOCRate,
  [dashboardCompareKeyTrackedAds]: dashboardTitleTrackedAds,
  [dashboardCompareKeyImpressionsRendered]: dashboardTitleImpressionsRendered,
  [dashboardCompareKeyRenderRate]: dashboardTitleRenderRate,
  [dashboardCompareKeyInvalidTrafficAds]: dashboardTitleInvalidTrafficAds,
  [dashboardCompareKeyInvalidTrafficRate]: dashboardTitleInvalidTrafficRate,
  [dashboardCompareKeyEligibleAds]: dashboardTitleEligibleAds,
  [dashboardCompareKeyMeasuredAds]: dashboardTitleMeasuredAds,
  [dashboardCompareKeyMeasuredRate]: dashboardTitleMeasuredRate,
  [dashboardCompareKeyViewableImpressions]: dashboardTitleViewableImpressions,
  [dashboardCompareKeyViewableRate]: dashboardTitleViewableRate,
  [dashboardCompareKeyBlockedAds]: dashboardTitleBlockedAds,
  [dashboardCompareKeyBlockedRate]: dashboardTitleBlockedRate,
  [dashboardCompareKeySuspiciousImps]: dashboardTitleSuspiciousImps,
  [dashboardCompareKeyUnsuspiciousImps]: dashboardTitleUnsuspiciousImps,
  [dashboardCompareKeyUnviewableImps]: dashboardTitleUnviewableImps,
  [dashboardCompareKeyBlockedImps]: dashboardTitleBlockedImps,
  [dashboardCompareKeyPassedAds]: dashboardTitlePassedAds,
  [dashboardCompareKeyAudibleViewableCustomQ2]: dashboardTitleAudibleViewableCustomQ2,
  [dashboardCompareKeyAudibleViewableIndStdQ4]: dashboardTitleAudibleViewableIndStdQ4,
  [dashboardCompareKeyAVOCGroupMRate]: dashboardTitleAVOCGroupMRate,
  [dashboardCompareKeyAVOCRate]: dashboardTitleAVOCRate,
} as Record<string, FirstAndThirdPartyDashboardCardDataTitles>;

// ---------------------- First And Third Party dashboard -----------------------------

export enum FirstOrThirdPartyDeviceType {
  Desktop_Web_Display = '111',
  Desktop_Web_Video = '112',
  Mobile_Web_Display = '121',
  Mobile_Web_Video = '122',
  Tablet_Web_Display = '131',
  Tablet_Web_Video = '132',
  Browser_CTV_Video = '152',
  Mobile_In_App_Display = '221',
  Mobile_In_App_Video = '222',
  Tablet_In_App_Display = '231',
  Tablet_In_App_Video = '232',
  CTV_In_App_Video = '252',
}

export interface IFirstOrThirdPartyDeviceType {
  key: FirstOrThirdPartyDeviceType;
  text: string;
}

export type FirstOrThirdParty = 'First Party' | 'Third Party';

export function getFirstOrThirdPartyDeviceTypes(
  party: FirstOrThirdParty,
): IFirstOrThirdPartyDeviceType[] {
  const deviceTypes = [
    {
      key: FirstOrThirdPartyDeviceType.Desktop_Web_Display,
      text: 'Desktop Web Display',
    },
    {
      key: FirstOrThirdPartyDeviceType.Desktop_Web_Video,
      text: 'Desktop Web Video',
    },
    {
      key: FirstOrThirdPartyDeviceType.Mobile_Web_Display,
      text: 'Mobile Web Display',
    },
    {
      key: FirstOrThirdPartyDeviceType.Mobile_Web_Video,
      text: 'Mobile Web Video',
    },
    {
      key: FirstOrThirdPartyDeviceType.Tablet_Web_Display,
      text: 'Tablet Web Display',
    },
    {
      key: FirstOrThirdPartyDeviceType.Tablet_Web_Video,
      text: 'Tablet Web Video',
    },
    {
      key: FirstOrThirdPartyDeviceType.Mobile_In_App_Display,
      text: 'Mobile In App Display',
    },
    {
      key: FirstOrThirdPartyDeviceType.Mobile_In_App_Video,
      text: 'Mobile In App Video',
    },
    {
      key: FirstOrThirdPartyDeviceType.Tablet_In_App_Display,
      text: 'Tablet In App Display',
    },
    {
      key: FirstOrThirdPartyDeviceType.Tablet_In_App_Video,
      text: 'Tablet In App Video',
    },
    {
      key: FirstOrThirdPartyDeviceType.CTV_In_App_Video,
      text: 'CTV In App Video',
    },
  ] as IFirstOrThirdPartyDeviceType[];

  if (party === 'Third Party') {
    deviceTypes.push({
      key: FirstOrThirdPartyDeviceType.Browser_CTV_Video,
      text: 'Browser CTV Video',
    });
  }

  return deviceTypes;
}

export function getFirstOrThirdPartyDeviceTypesAsIMenu(party: FirstOrThirdParty): IMenuList {
  const out = {} as IMenuList;
  const deviceTypes = getFirstOrThirdPartyDeviceTypes(party);
  for (const d of deviceTypes) {
    out[d.key] = {
      selected: false,
      ID: d.key,
      title: d.text,
    } as IListItem;
  }

  return out;
}
